module.exports = __webpack_public_path__ + "img/bank-of-america.3edf3221.png";